import { Divider, capitalize } from '@mui/material';
import { InfoItem, SidebarItem } from '/src/components';
import { Loan } from '/src/lib/models';
import { LoanType } from '/src/lib/types';

export type LoanInformationProps = {
  /**
   * Whether this component is visible
   */
  open: boolean;
  /**
   * Toggles component visibility
   * @returns void
   */
  toggleOpen: () => void;
  /**
   * Loan to display information for
   */
  loan?: Loan;
};

export const LoanInformation: React.FC<LoanInformationProps> = ({ loan, open, toggleOpen }) => (
  <SidebarItem title="Deal Details" open={open} toggleOpen={toggleOpen} resolved={!!loan}>
    <InfoItem title="Company" value={loan?.borrower.name} url={`/companies/${loan?.borrower._id}`} smallFont />
    <Divider />
    <InfoItem title="Created On" value={loan?.created} date smallFont />
    <InfoItem title="Type" value={loan?.isOwned ? LoanType.Owned : LoanType.Loan} smallFont />
    <InfoItem title="Status" value={capitalize(loan?.status ?? '')} smallFont />
    <Divider />
    <InfoItem title="Amount" bold value={loan?.amount} currency smallFont />
    {!loan?.isOwned && (
      <>
        <Divider />
        <InfoItem title="Term" value={`${loan?.term} Months`} smallFont />
        <InfoItem title="Maturity Date" value={loan?.maturityDate} date smallFont />
        <InfoItem title="Last Advance Date" value={loan?.lastAdvanceDate} date smallFont />
        <InfoItem title="Minimum Payment Method" value={loan?.minPmtMethod} smallFont />
        {!!loan?.minimumPayment && <InfoItem title="Minimum Payment" value={loan.minimumPayment} currency smallFont />}
        {!!loan?.payDownPercent && <InfoItem title="Pay Down Percent" value={loan.payDownPercent} percent smallFont />}
      </>
    )}
  </SidebarItem>
);
